import axios from 'axios'

// export default () => {
//   return axios.create({
//     baseURL: 'http://localhost:3003'
//     // headers: { 'Access-Control-Allow-Origin': '*' }
//   })
// }

// TODO: should this just be created once? Seems that every route creates its own Api() instance on every call.
//       but this is probably quite lightweight
export default () => {
  return axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL
    // headers: { 'Access-Control-Allow-Origin': '*' }
  })
}
